import { render, staticRenderFns } from "./Flight.vue?vue&type=template&id=6a5ab1ef&scoped=true&"
import script from "./Flight.vue?vue&type=script&lang=js&"
export * from "./Flight.vue?vue&type=script&lang=js&"
import style0 from "./Flight.vue?vue&type=style&index=0&id=6a5ab1ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5ab1ef",
  null
  
)

export default component.exports